export function query (selector) {
  return Array.from(document.querySelectorAll(selector))
}

// export function _query (selector) {
//   return document.querySelector(selector)
// }

export const _query = selector => document.querySelector(selector)